import axios from "axios";
import toast from "react-hot-toast";
const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const emailList = (emailData, showLoader = true) => {
  return async (dispatch) => {
    if (showLoader) dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "EMAIL_LIST_REQUEST" });

      const axiosConfig = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${BASE_URL}/email/list`,
        emailData,
        axiosConfig
      );

      if (data.statusCode === 200) {
        dispatch({ type: "EMAIL_LIST_SUCCESS", payload: data });
        dispatch({ type: "SET_FETCHED_TIME", payload: Date.now() });
      } else {
        dispatch({ type: "EMAIL_LIST_FAIL", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "EMAIL_LIST_FAIL",
        payload: error?.response?.data?.message,
      });
    } finally {
      if (showLoader) dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const emailAdd = (emailData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "EMAIL_ADD_REQUEST" });

      const axiosConfig = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${BASE_URL}/email/add`,
        emailData,
        axiosConfig
      );

      if (data.statusCode === 200) {
        dispatch({ type: "EMAIL_ADD_SUCCESS", payload: data });
        toast.success("Email Added Successfully!");
        return data;
      } else {
        dispatch({ type: "EMAIL_ADD_FAIL", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "EMAIL_ADD_FAIL",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const emailUpdate = (emailData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "EMAIL_UPDATE_REQUEST" });

      const axiosConfig = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${BASE_URL}/email/update/${emailData.id}`,
        emailData,
        axiosConfig
      );

      if (data.statusCode === 200) {
        dispatch({ type: "EMAIL_UPDATE_SUCCESS", payload: data });
        toast.success("Email Updated Successfully!");
        return data;
      } else {
        dispatch({ type: "EMAIL_UPDATE_FAIL", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "EMAIL_UPDATE_FAIL",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message);
      return error?.response?.data?.message;
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const emailRemove = (emailId) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "EMAIL_REMOVE_REQUEST" });

      const axiosConfig = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${BASE_URL}/email/remove/${emailId}`,
        {},
        axiosConfig
      );

      if (data.statusCode === 200) {
        dispatch({ type: "EMAIL_REMOVE_SUCCESS", payload: data });
        toast.success("Email Removed Successfully!");
        return data;
      } else {
        dispatch({ type: "EMAIL_REMOVE_FAIL", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "EMAIL_REMOVE_FAIL",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};
